import React from 'react';
import { AppShell } from './AppShell';
import { MobileShell } from './MobileShell';
import { ClientShell } from './ClientShell';
import { ClientMobileShell } from './ClientMobileShell';

// All four shells share the same external contract; an explicit return type
// keeps the inferred signature from referencing each shell's (unexported) props
// interface (which otherwise triggers TS4023 under declaration emit).
type ShellComponent = React.ComponentType<{
  history: { push: (path: string) => void; location: { pathname: string } };
  onLogout: () => void;
  children: React.ReactNode;
}>;

/**
 * Selects the shell chrome for a user. External (client) users get the dedicated
 * client shells; internal users get the existing, untouched staff shells.
 */
export const pickShell = (
  isExternal: boolean,
  isMobile: boolean
): ShellComponent => {
  if (isExternal) return isMobile ? ClientMobileShell : ClientShell;
  return isMobile ? MobileShell : AppShell;
};
